import SpritesheetViewer from '../../../components/SpritesheetViewer';
import { useAdminContext } from '../AdminContext';

export default function SpritesheetsTab() {
  const { subreddit, user, isSiteAdmin, isSubscribed } = useAdminContext();
  const canManageSpritesheets = !!(
    isSiteAdmin ||
    (user?.isModerator && user?.moderatorSubreddit === subreddit)
  );
  return (
    <SpritesheetViewer
      subreddit={subreddit || ''}
      canManageSpritesheets={canManageSpritesheets}
      isSubscribed={isSubscribed}
    />
  );
}
